module.exports = __webpack_public_path__ + "img/chinesecompany148.39da0c39.png";